export default {
    data() {
        return {
            // inject:['reload'],
            all: 0, //总页数
            cur: 1,//当前页码
            payLenth:0,
            completedLenth:0,
            expiredLenth:0,
            boughtFlag:'',
            // 商品的数组
            orders: [],
            // 支付方式的数组
            pay_type: ['支付宝','微信','线下开通','银联','账号余额']
        }
    },
    methods: {
        orderFinished: function () {
            // alert('展示已经完成订单数据拉');
            
        },
        orderNoPay: function () {
            // alert('展示未完成订单数据拉');
        },
        orderCancel: function () {
            // alert('展示失效得订单数据拉');
        },
        goIndex: function () {
            // alert('跳转到首页');
            this.$router.push({
                path: '/'
            })
        },
        // 跳转到个人中心
        goPersonalcenter: function () {
            this.$router.push({
                path: '/personalcenter'
            })
        },
        //去支付，跳转支付中心
        goPaycenter: function (val) {
            if(!this.boughtFlag){
                alert('已经购买了');
                return;
            }
            let code=val.code;
            let arr=[];
            let id=val.id;
            for(let v of val.purchased){
                arr.push(v.product_id);
            }
            this.$router.push({
                path:'/paycenter',
                query:{
                    code:code,
                    commodityList:JSON.stringify(arr),
                    order_id:id
                }
            });
        },
        //全部页和未支付页的取消订单
        cancelOrder:function(id){
            this.$post('orders/cancel',{id:id,token: this.$store.state.id,state:'5'}).then(res=>{
                this.getMyorder();
            })
        },
        // classDetails: function (id) {
        //     this.$post('orders/searchCourses', { token: this.$store.state.id, offset: '0', length: '6', state: '2' }).then(res => {
        //         let arr=[];
        //         for(let val of res.data.result.data){
        //             arr.push(Number.parseFloat(val.product_id));
        //         }
        //         return arr;
        //     }).then(data => {
        //         if(data.indexOf(Number.parseFloat(id))===-1){
        //             this.$router.push({
        //                 path: '/classdetails',
        //                 query:{
        //                     id: id
        //                 }
        //             })
        //         }else{
        //             this.$router.push({
        //                 path: '/classstudy',
        //                 query:{
        //                     id: id
        //                 }
        //             })
        //         }
        //     })
        // },
        //获取订单数据
        getMyorder:function(){
            this.$post('orders/search',{token: this.$store.state.id,offset:0,length:999}).then(res=>{
                this.orders=[];
                this.all=parseInt(this.all);
                this.orders.code=res.data.result.data.code;
                return res.data.result.data;
            }).then(data=>{
                let me = this;
                for (let val of data) {
                    -function (val) {
                        me.$post('purchased/search', {token: me.$store.state.id,order_id: val.id,offset:0,length:'999'}).then(res1 => {
                            let obj ={
                                id:val.id,
                                created_at:val.created_at,
                                code:val.code,
                                invoice_title: val.invoice_title,
                                owner_id: val.owner_id,
                                state: val.state,
                                pay_type:val.pay_type,
                                tax_no:val.tax_no,
                                total:val.total,
                                purchased:res1.data.result.data,
                            }
                            me.orders.push(obj);
                            for(let val of me.orders){
                                if(Number.parseInt(val.state)===0){
                                    me.payLenth='1';
                                }else if(Number.parseInt(val.state)===2){
                                    me.completedLenth='1';
                                }else{
                                    me.expiredLenth='1';
                                }
                        }
                    })
                }(val)
            }
            });
            
        },
         //判断商品是否已经购买过了
         isBought:function(val){
            // // console.log(val.purchased);
            // for(let val of val.purchased){
                
            // }
            let arr = val.purchased
            for(let i=0;i<arr.length;i++){
                this.$post('users/isPay', { product_id: Number.parseFloat(arr[i].product_id), token: this.$store.state.id }).then(res=>{
                    if(res.data.result != true){
                        this.boughtFlag=false;
                        this.goPaycenter(val);
                        return;
                    }else if(i==arr.length-1){
                        this.boughtFlag=true;
                        this.goPaycenter(val);
                        return;
                    }
                })
            } 
        }
    },

    created: function () {
        this.getMyorder();
    },
    mounted: function () {
        document.title='我的订单';
    }
}

